import {ToastContainer} from 'react-toastify';
import Header from './header/Header';
import MainRouting from './MainRouting';
import 'react-toastify/dist/ReactToastify.css';

import Login from "./pages/login/Login";
import {Route, Routes} from "react-router-dom";
import Protected from "../utils/protected/Protected";
import UserContextProvider from "../state/UserContext";
import OfficeContextProvider from "../state/OfficeContext";


const App = () => {

    return (
        <div className="App">
            <UserContextProvider>

                <Routes>
                    <Route path="/login" element={<Login/>}/>
                    <Route
                        path="*"
                        element={
                            <Protected>
                                <OfficeContextProvider>
                    <ToastContainer autoClose={7000}/>
                    <Header/>
                    <MainRouting/>
                                </OfficeContextProvider>
                            </Protected>
                        }/>
                </Routes>
            </UserContextProvider>


        </div>
    );
}

export default App;
